import styled from 'styled-components';

import { STYLE } from './constants';

const HighlightText = styled.span`
  font-weight: 500;
  color: ${STYLE.colorClick};
`;

export default HighlightText;
